import React from "react";
import { string } from "prop-types";
import { DATA_SPACER } from "#library/constants/enums";
import { Text, TEXT_TYPES, TEXT_COLORS, TEXT_ALIGNS } from "#library/components/Text/Text";
import { useModal } from "#library/components/Modal/ModalManagement/ModalContext";
export var ModalSubTitle = function ModalSubTitle(_ref) {
  var children = _ref.children;
  var _useModal = useModal(),
    withIllustration = _useModal.withIllustration;
  var textAlign = withIllustration ? TEXT_ALIGNS.CENTER : TEXT_ALIGNS.LEFT;
  return /*#__PURE__*/React.createElement(Text, {
    id: "dialogDesc",
    tag: "div",
    color: TEXT_COLORS.GREY,
    type: TEXT_TYPES.SMALL,
    align: textAlign,
    resetSpacing: true,
    dataSpacer: DATA_SPACER.TOP_50
  }, children);
};
ModalSubTitle.propTypes = {
  children: string.isRequired
};